import * as React from "react";
import {CSSProperties, ReactElement, ReactNode} from "react";

import {CSSProp} from "styled-components";
import {DocumentManager} from "../../../Manager/PDFManager/DocumentManager";
import {FieldSettings} from "../FieldSettings";
import Tooltip from "react-tooltip-lite";
import {faQuestionCircle} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "shared/core/Controls/FontAwesome/FontAwesomeIcon";

export abstract class PropertyBase{
    public label:string;
    private customStyles: any=null;
    protected _focus:boolean=false;
    protected _onChange:(newValue:string)=>void;
    protected _ignoreRefresh:boolean=false;
    private OptionsOverWrite:any;
    public $element:JQuery;
    public isHidden:boolean;
    public disabled:boolean=false;
    public PropertyContainer:PropertyContainer;
    public ExternalValue:any=null;
    protected customClass:string='';
    public CallBack:(value)=>void;

    public get Options(){
        if(this.OptionsOverWrite!=null)
            return this.OptionsOverWrite;
        else
            return this.fieldSettings.props.DocumentManager.SelectedPDFField?.GetFieldSettings();
    }

    public Show(){
        this.isHidden=false;
        if(this.$element!=null)
            this.$element.slideDown();
        return this;
    }

    public Hide(){
        this.isHidden=true;
        if(this.$element!=null)
            this.$element.slideUp();
        return this;
    }



    constructor(public fieldSettings:FieldSettings, public OptionsPropertyName:string, OptionsOverWrite:any=null)
    {
        this.OptionsOverWrite=OptionsOverWrite;
    }

    public SetDisabled(disabled=true){
        this.disabled=disabled;
        if(this.PropertyContainer!=null)
            this.PropertyContainer.ForceUpdate();
        return this;

    }

    public GetOptionsOverWrite(){
        return this.OptionsOverWrite;
    }

    public SetOptionsoverWrite(optionsOverWrite:any){
        this.OptionsOverWrite=optionsOverWrite;
    }

    public IgnoreRefresh(){
        this._ignoreRefresh=true;
        return this;
    }

    public OnChange(callback:(newValue:string)=>void)
    {
        this._onChange=callback;
        return this;
    }


    public SetLabel(label:string)
    {
        this.label=label;
        return this;
    }

    public AddStyles(customStyles:CSSProperties){
        this.customStyles=customStyles;
        return this;
    }

    public AddCustomClass(className:string)
    {
        this.customClass=className;
        return this;
    }

    public Focus(){
        this._focus=true;
        return this;
    }


    public GetTooltip(content:ReactElement):ReactElement{

        if(content==null)
            return null;

        return (
            <Tooltip content={content} background={'black'} color={'white'} styles={{display:'inline-block',zIndex: 100000}}>
                <span style={{marginLeft:2,cursor:'pointer'}}><FontAwesomeIcon icon={faQuestionCircle}/></span>
            </Tooltip>
        )
    }

    public SetExternalValue(value:any)
    {
        this.ExternalValue=value;
        return this;
    }

    public GetBooleanValue(propertyName:string=''){
        let value=this.GetOptionValue(propertyName);
        if(value=='')
            return false;
        return true;
    }

    public GetOptionValue(propertyName:string=''){
        if(this.ExternalValue!=null)
            return this.ExternalValue;
        if(propertyName=='')
            propertyName=this.OptionsPropertyName;


        if(typeof this.Options[propertyName]=='undefined')
            return '';
        return this.Options.GetValue(propertyName);
    }

    public SetOnChangeExternalValue(callBack:(value)=>void)
    {
        this.CallBack=callBack;
        return this;
    }

    public SetOptionValue(value:any,propertyName:string=''){

        if(this.CallBack!=null) {
            this.CallBack(value)
            this.ForceUpdate();
            return;
        }

        if(propertyName=='')
            propertyName=this.OptionsPropertyName;



        this.Options.SetValue(propertyName,value);
        if(this._onChange!=null)
            this._onChange(value);
        if(!this._ignoreRefresh)
            this.fieldSettings.Refresh();
        this.ForceUpdate();

    }


    public ForceUpdate(){
        this.PropertyContainer.ForceUpdate();
    }

    protected GetPropertyTemplate():JQuery {
        return jQuery(`<div style="opacity: 0" class="fieldProperty ${this.customClass}">
                                        <label style="display:block;">${this.label}</label>
                                        <div class="propertyContent" style="min-height: 1px;"></div>
                                    </div>`)
    }

    public renderer(id:string){
        return (
            <PropertyContainer key={id} CustomStyles={this.customStyles} ref={e=>this.PropertyContainer=e} Parent={this}>

            </PropertyContainer>

        );
    }


    public abstract SubRenderer():ReactNode;

    ComponentDidMount() {

    }
}


class PropertyContainer extends React.Component<PropertyContainerProps>{
    render(): React.ReactNode {
        return(
            <div style={{...this.props.CustomStyles,marginBottom:5}}>
                <div>
                    {this.props.Parent.SubRenderer()}
                </div>
            </div>
        )
    }

    componentDidMount(): void {
        this.props.Parent.ComponentDidMount();
    }

    public ForceUpdate(){
        super.forceUpdate();
    }
}

interface PropertyContainerProps {
    CustomStyles:CSSProperties;
    Parent:PropertyBase;
}

